import { useState } from 'react'
import { Segmented } from 'antd'
import { TableSearch, SearchFilterModal, type FilterCondition, type FilterableField } from '@/components/ui'
import type { SegmentedValue } from 'antd/es/segmented'

import type { PushNotificationFilter } from './types'

const segmentedOptions = [
  { label: 'All', value: 'all' },
  { label: 'Draft', value: 'draft' },
  { label: 'Sent', value: 'sent' },
]

const filterFields: FilterableField[] = [
  {
    id: 'status',
    identifier: 'status',
    label: 'Status',
    type: 'select',
    options: [
      { label: 'Draft', value: 'draft' },
      { label: 'Sent', value: 'sent' },
    ],
  },
]

interface FiltersBarProps {
  searchValue: string
  statusFilter: PushNotificationFilter
  onSearchChange: (value: string) => void
  onStatusChange: (value: PushNotificationFilter) => void
  onSearch: () => void
  onReset: () => void
}

export const FiltersBar: React.FC<FiltersBarProps> = ({
  searchValue,
  statusFilter,
  onSearchChange,
  onStatusChange,
  onSearch,
  onReset,
}) => {
  const [filterModalOpen, setFilterModalOpen] = useState(false)
  const [filterConditions, setFilterConditions] = useState<FilterCondition[]>([])
  const [filterNameSearch, setFilterNameSearch] = useState('')

  const handleApplyFilters = () => {
    // Apply name search
    if (filterNameSearch) {
      onSearchChange(filterNameSearch)
      onSearch()
    }

    // Apply status filter from conditions
    const statusCondition = filterConditions.find(c => c.field === 'status' && c.value)
    if (statusCondition) {
      onStatusChange(statusCondition.value as PushNotificationFilter)
    }

    setFilterModalOpen(false)
  }

  const handleResetFilters = () => {
    setFilterNameSearch('')
    setFilterConditions([])
    onReset()
    onStatusChange('all')
    setFilterModalOpen(false)
  }

  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <TableSearch
          value={searchValue}
          onChange={onSearchChange}
          onSearch={onSearch}
          onReset={onReset}
          onFilter={() => setFilterModalOpen(true)}
          placeholder="Search Push Notification"
          showFilter={true}
        />

        <Segmented
          options={segmentedOptions}
          value={statusFilter}
          onChange={(value: SegmentedValue) =>
            onStatusChange(value as PushNotificationFilter)
          }
          className="ava-segmented"
        />
      </div>

      <SearchFilterModal
        open={filterModalOpen}
        onClose={() => setFilterModalOpen(false)}
        title="Filter Push Notifications"
        description="Show notifications that match the following..."
        fields={filterFields}
        filterConditions={filterConditions}
        onFilterConditionsChange={setFilterConditions}
        showNameSearch={true}
        nameSearchPlaceholder="Search notification title"
        nameSearchValue={filterNameSearch}
        onNameSearchChange={setFilterNameSearch}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
    </div>
  )
}
